(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui-universal/primitive-utilities"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities")) : factory(root["underscore"], root["@bingads-webui-universal/primitive-utilities"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Instrumentation", {
  enumerable: true,
  get: function get() {
    return _instrumentation.Instrumentation;
  }
});
Object.defineProperty(exports, "Logger", {
  enumerable: true,
  get: function get() {
    return _logger.Logger;
  }
});
Object.defineProperty(exports, "constants", {
  enumerable: true,
  get: function get() {
    return _constants.constants;
  }
});

var _instrumentation = __webpack_require__(2);

var _logger = __webpack_require__(8);

var _constants = __webpack_require__(7);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Instrumentation = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _defaultConfig = __webpack_require__(4);

var _loggingService = __webpack_require__(14);

var _logTransmitter = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class representing Instrumentation
 */
class Instrumentation {
  /**
   * Create an instance of Instrumentation
   * @param {object} config - should contain a config of loggers/processors/listeners:
   * loggers - specify custom loggers to override or add to the default trace, perf, error loggers.
   * processors - specify custom log processors to modify or enrich the logs.
   * listeners - specify listeners to write logs to.
   * isDebugMode - specify if it's in debug mode or not. Default to false. It will throw error
   * if (scenario, activity) pair has already been registered before in debug mode
   */
  constructor(config = {}) {
    this.setup(config); // scenarioContext maintains the current scenario in use.

    this.scenarioContext = {};
    this.initTransmissionService(this.scenarioContext);
    this.initLoggingService();
  }

  setup(config) {
    const defaultConfig = (0, _defaultConfig.getDefaultConfig)();
    this.loggers = _underscore.default.defaults(config.loggers || {}, defaultConfig.loggers);
    this.processors = _underscore.default.defaults(config.processors || {}, defaultConfig.processors);
    this.listeners = _underscore.default.defaults(config.listeners || {}, defaultConfig.listeners);
    this.isDebugMode = config.isDebugMode || defaultConfig.isDebugMode;
    window.addEventListener('unload', () => this.stop());
  }

  stop() {
    this.beforeStop();
    this.logTransmitter.stop();
  }

  initTransmissionService(scenarioContext) {
    this.logTransmitter = new _logTransmitter.LogTransmitter({
      scenarioContext,
      processors: this.processors,
      listeners: this.listeners
    });

    this.writeRawLog = rawLogs => this.logTransmitter.transmit(rawLogs);
  }

  initLoggingService() {
    _underscore.default.each(this.loggers, logger => {
      logger.logTransmitter = this.logTransmitter; // eslint-disable-line no-param-reassign
    });

    this.loggingService = new _loggingService.LoggingService({
      loggers: this.loggers,
      isDebugMode: this.isDebugMode
    });
  }
  /**
   * adds specified scenarios on to the instrumentation instance
   * @param {object} scenarioSchema - schema that specifies the scenarios to be added
   * @returns {Instrumentation} - return self for chaining
   */


  addScenario(scenarioSchema) {
    _underscore.default.extend(this, this.loggingService.parseSchema(scenarioSchema));

    return this;
  }
  /**
   * add simple scenario and activity for one time use
   * @param {object} scenarioContext - scenario context such as name, parentScenario
   * @returns {object} - activity instance ready to call logger methods
   * usage would be: instrumentation.createScenarioAndActivity("scenario", "activity")
   * DO NOT use this if the scenario is created multiple times, in which case
   * the scenarioId would be different
   *  .signal("something happened")
   */


  createScenarioAndActivity(scenarioContext) {
    const parentScenario = scenarioContext.parentScenario,
          scenarioName = scenarioContext.scenarioName,
          activityName = scenarioContext.activityName; // build the scenario schema with activity

    const schema = {
      scenario: [{
        name: scenarioName,
        value: scenarioName,
        activity: activityName ? [activityName] : []
      }]
    };
    this.addScenario(schema);
    const scenario = this[scenarioName].create(parentScenario);
    const activity = activityName ? scenario[activityName].create() : undefined;
    return {
      scenario,
      activity
    };
  }
  /**
   * add simple scenario and activity for one time use
   * @param {object} scenarioContext - scenario context such as name, parentScenario
   * @returns {object} - scenario instance
   */


  createScenario(scenarioContext) {
    return this.createScenarioAndActivity(scenarioContext).scenario;
  }
  /**
   * method for custom logic to be run before the instrumentation service exits
   * can be overridden
   * @returns {undefined} - no returns
   */


  beforeStop() {
    _underscore.default.noop();
  }

  get ScenarioContext() {
    return this.scenarioContext;
  }

}

exports.Instrumentation = Instrumentation;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultConfig = getDefaultConfig;

var _traceLogger = __webpack_require__(5);

var _perfLogger = __webpack_require__(9);

var _errorLogger = __webpack_require__(10);

var _ajaxLogger = __webpack_require__(11);

var _scenarioProcessor = __webpack_require__(12);

var _substrateLogger = __webpack_require__(13);

function getDefaultConfig() {
  // default loggers
  const traceLogger = new _traceLogger.TraceLogger();
  const perfLogger = new _perfLogger.PerfLogger();
  const errorLogger = new _errorLogger.ErrorLogger();
  const ajaxLogger = new _ajaxLogger.AjaxLogger();
  const substrateLogger = new _substrateLogger.SubstrateLogger(); // default processors

  const scenarioProcessor = new _scenarioProcessor.ScenarioProcessor();
  return {
    isDebugMode: false,
    loggers: {
      traceLogger,
      errorLogger,
      perfLogger,
      ajaxLogger,
      substrateLogger
    },
    processors: {
      scenarioProcessor
    },
    listeners: {}
  };
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TraceLogger = void 0;

var _primitiveUtilities = __webpack_require__(6);

var _constants = __webpack_require__(7);

var _logger = __webpack_require__(8);

/**
 * Default Trace Logger
 */
class TraceLogger extends _logger.Logger {
  /**
   * trace - logs passed in args as trace logs
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - args passed in to the trace log method
   * @returns {undefined} - no returns
   */
  trace(scenario, activity, parentScenario, [message, api, requestId, httpMethod, logLevel]) {
    super.log({
      api,
      message,
      requestId,
      httpMethod,
      timeStamp: (0, _primitiveUtilities.getUtcTime)(),
      logCategory: _constants.constants.LOGCATEGORY.TRACE,
      logLevel: logLevel || _constants.constants.LOGLEVEL.INFO,
      entryType: _constants.constants.ENTRYTYPE.MESSAGE,
      activity,
      scenario,
      parentScenario
    });
  }

  getLogMethods() {
    return ['trace'];
  }

}

exports.TraceLogger = TraceLogger;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constants = void 0;
const constants = {
  IMPACTUSER: {
    True: true,
    False: false,
    NA: null
  },
  LOGLEVEL: {
    INFO: {
      name: 'Info',
      value: 0
    },
    DEBUG: {
      name: 'Debug',
      value: 1
    },
    VERBOSE: {
      name: 'Verbose',
      value: 2
    }
  },
  LOGCATEGORY: {
    PERFORMANCE: 'ClientPerf',
    ERROR: 'ApplicationErrorClientScript',
    TRACE: 'ClientTrace',
    SUBSTRATE: 'Substrate'
  },
  ENTRYTYPE: {
    SCENARIO: 'Scenario',
    ACTIVITY: 'Activity',
    AJAX: 'Ajax',
    AJAXRENDER: 'AjaxRender',
    METHOD: 'Method',
    MESSAGE: 'Message'
  }
};
exports.constants = constants;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = void 0;

/**
 * Base Logger
 */
class Logger {
  /**
   * log - transmits logs to the log transmitter
   * @param {object} rawLogs - raw logs to be transmitted
   * @returns {undefined} - no returns
   */
  log(rawLogs) {
    this.transmitter.transmit(rawLogs);
  }

  getLogMethods() {
    throw new Error('Not Implemented');
  }

  set logTransmitter(logTransmitter) {
    this.transmitter = logTransmitter;
  }

}

exports.Logger = Logger;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PerfLogger = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _primitiveUtilities = __webpack_require__(6);

var _constants = __webpack_require__(7);

var _logger = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Default Perf Logger
 */
class PerfLogger extends _logger.Logger {
  /**
   * start - used to measure start of an activity
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - api of activity
   * @returns {undefined} - no returns
   */
  start(scenario, activity, parentScenario, [api]) {
    super.log({
      api,
      isMethodEnter: true,
      timeStamp: (0, _primitiveUtilities.getUtcTime)(),
      logCategory: _constants.constants.LOGCATEGORY.PERFORMANCE,
      logLevel: _constants.constants.LOGLEVEL.INFO,
      entryType: _constants.constants.ENTRYTYPE.ACTIVITY,
      activity,
      scenario,
      parentScenario
    });
  }
  /**
   * stop - used to measure stop of an activity
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - result and api of activity
   * @returns {undefined} - no returns
   */


  stop(scenario, activity, parentScenario, [result, api]) {
    super.log({
      api,
      isMethodEnter: false,
      timeStamp: (0, _primitiveUtilities.getUtcTime)(),
      pass: _underscore.default.isUndefined(result) ? true : result,
      logCategory: _constants.constants.LOGCATEGORY.PERFORMANCE,
      logLevel: _constants.constants.LOGLEVEL.INFO,
      entryType: _constants.constants.ENTRYTYPE.ACTIVITY,
      activity,
      scenario,
      parentScenario
    });
  }
  /**
   * monitor - can be used to monitor and measure the duration of a function
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - function that is to be monitored and duration measured
   * @returns {undefined} - no returns
   */


  monitor(scenario, activity, parentScenario, [func, context]) {
    const originalFunc = context[func];

    if (!_underscore.default.isFunction(originalFunc)) {
      return;
    }

    context[func] = (...args) => {
      // eslint-disable-line no-param-reassign
      const t0 = (0, _primitiveUtilities.getTimestamp)();
      const result = originalFunc.apply(context, args);
      const timeTaken = (0, _primitiveUtilities.getTimestamp)() - t0;
      super.log({
        api: originalFunc.name,
        timeTaken,
        timeStamp: (0, _primitiveUtilities.getUtcTime)(),
        logCategory: _constants.constants.LOGCATEGORY.PERFORMANCE,
        logLevel: _constants.constants.LOGLEVEL.INFO,
        entryType: _constants.constants.ENTRYTYPE.METHOD,
        activity,
        scenario,
        parentScenario
      });
      return result;
    };
  }
  /**
   * monitorAsync - can be used to measure the duration of a promise
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - function that is async and returns a promise
   * @returns {undefined} - returns a promise with perf markers
   */


  monitorAsync(scenario, activity, parentScenario, [promise]) {
    const t0 = (0, _primitiveUtilities.getTimestamp)(); // log monitor start

    super.log({
      isMethodEnter: true,
      timeStamp: (0, _primitiveUtilities.getUtcTime)(),
      logCategory: _constants.constants.LOGCATEGORY.PERFORMANCE,
      logLevel: _constants.constants.LOGLEVEL.INFO,
      entryType: _constants.constants.ENTRYTYPE.METHOD,
      activity,
      scenario,
      parentScenario
    });

    const onPromiseDone = () => {
      const timeTaken = (0, _primitiveUtilities.getTimestamp)() - t0; // log monitor stop

      super.log({
        isMethodEnter: false,
        timeTaken,
        timeStamp: (0, _primitiveUtilities.getUtcTime)(),
        logCategory: _constants.constants.LOGCATEGORY.PERFORMANCE,
        logLevel: _constants.constants.LOGLEVEL.INFO,
        entryType: _constants.constants.ENTRYTYPE.METHOD,
        activity,
        scenario,
        parentScenario
      });
    };

    promise.then(onPromiseDone, onPromiseDone);
    return promise;
  }
  /**
   * perf - logs passed in args as perf logs
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - args passed in to the perf log method
   * @returns {undefined} - no returns
   */


  perf(scenario, activity, parentScenario, [message, api]) {
    super.log({
      api,
      message,
      timeStamp: (0, _primitiveUtilities.getUtcTime)(),
      logCategory: _constants.constants.LOGCATEGORY.PERFORMANCE,
      logLevel: _constants.constants.LOGLEVEL.INFO,
      entryType: _constants.constants.ENTRYTYPE.MESSAGE,
      activity,
      scenario,
      parentScenario
    });
  }

  getLogMethods() {
    return ['start', 'stop', 'monitor', 'monitorAsync', 'perf'];
  }

}

exports.PerfLogger = PerfLogger;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorLogger = void 0;

var _primitiveUtilities = __webpack_require__(6);

var _constants = __webpack_require__(7);

var _logger = __webpack_require__(8);

/* eslint-disable max-len */

/**
 * Default Error Logger
 */
class ErrorLogger extends _logger.Logger {
  /**
   * error - logs passed in args as error logs
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - args passed in to the error log method
   * @returns {undefined} - no returns
   */
  error(scenario, activity, parentScenario, [message, api, requestId, impactUser, httpMethod, logLevel]) {
    super.log({
      api,
      message,
      requestId,
      impactUser: impactUser || _constants.constants.IMPACTUSER.NA,
      httpMethod,
      timeStamp: (0, _primitiveUtilities.getUtcTime)(),
      logCategory: _constants.constants.LOGCATEGORY.ERROR,
      logLevel: logLevel || _constants.constants.LOGLEVEL.INFO,
      entryType: _constants.constants.ENTRYTYPE.MESSAGE,
      activity,
      scenario,
      parentScenario
    });
  }

  getLogMethods() {
    return ['error'];
  }

}

exports.ErrorLogger = ErrorLogger;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxLogger = void 0;

var _primitiveUtilities = __webpack_require__(6);

var _constants = __webpack_require__(7);

var _logger = __webpack_require__(8);

/**
 * Ajax Logger - internal logger that can used by for logging Ajax calls
 */
class AjaxLogger extends _logger.Logger {
  /**
   * ajax - logs passed in args as ajax logs
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} args - args passed in to the ajax log method
   * @returns {undefined} - no returns
   */
  ajax(scenario, activity, parentScenario, [requestId, api, isMethodEnter, httpMethod, timeTaken, pass, message, entityCount, includeRendering]) {
    super.log({
      requestId,
      api,
      isMethodEnter,
      httpMethod,
      timeTaken,
      pass,
      message,
      entityCount,
      entryType: includeRendering === true ? _constants.constants.ENTRYTYPE.AJAXRENDER : _constants.constants.ENTRYTYPE.AJAX,
      timeStamp: (0, _primitiveUtilities.getUtcTime)(),
      logLevel: _constants.constants.LOGLEVEL.INFO,
      logCategory: _constants.constants.LOGCATEGORY.PERFORMANCE,
      activity,
      scenario,
      parentScenario
    });
  }

  getLogMethods() {
    return ['ajax'];
  }

}

exports.AjaxLogger = AjaxLogger;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScenarioProcessor = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ScenarioProcessor class responsible for enriching logs with scenario/activity information
 */
class ScenarioProcessor {
  process(rawLogs) {
    if (!_underscore.default.has(rawLogs, 'scenario')) {
      return rawLogs;
    }

    let logs = _underscore.default.extend(rawLogs, {
      activityId: rawLogs.activity.id,
      activityName: rawLogs.activity.value,
      scenarioId: rawLogs.scenario.id,
      scenarioName: rawLogs.scenario.value,
      parentScenarioId: rawLogs.parentScenario && rawLogs.parentScenario.id,
      parentScenarioName: rawLogs.parentScenario && rawLogs.parentScenario.value
    }); // drop activity/scenario/parentScenarioScenario since we've already extracted the needed info


    logs = _underscore.default.omit(logs, 'activity', 'scenario', 'parentScenario');
    return logs;
  }

}

exports.ScenarioProcessor = ScenarioProcessor;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubstrateLogger = void 0;

var _constants = __webpack_require__(7);

var _logger = __webpack_require__(8);

/* eslint-disable no-param-reassign */

/**
 * Substrate Logger to log events for user behavior analysis
 * Key data entries include
 * Sn: scenario name
 * SceId: scenario id, this is re-generated whenever a scenario is created
 * An: activity name
 * ActId: activity id, this is re-generated when an activity is created
 * Mes: a custom message for the signal
 * Dur: time taken for the signal
 */
class SubstrateLogger extends _logger.Logger {
  /**
   * startSignal - used to measure start of a signal
   * @param {object} scenario - scenario that defines the activity
   * @param {object} activity - activity that invoked the log method
   * @returns {undefined} - no returns
   */
  startSignal(scenario, activity) {
    if (!scenario || !activity) {
      return;
    }

    activity.startTime = new Date();
  }
  /**
   * stopSignal - used to measure stop of an activity
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {boolean} trackDuration - indicate if the signal needs to track time taken
   * @param {object} message - a custom message for the activity itself
   * @returns {undefined} - no returns
   */


  stopSignal(scenario, activity, parentScenario, [message, api, trackDuration = true]) {
    if (!scenario || !activity || trackDuration && !activity.startTime) {
      return;
    }

    const endTime = new Date();
    super.log({
      timeStamp: trackDuration ? activity.startTime.toJSON() : endTime.toJSON(),
      timeTaken: trackDuration ? endTime - activity.startTime : 0,
      logCategory: _constants.constants.LOGCATEGORY.SUBSTRATE,
      logLevel: _constants.constants.LOGLEVEL.INFO,
      entryType: _constants.constants.ENTRYTYPE.ACTIVITY,
      activity,
      scenario,
      parentScenario,
      message,
      api
    });
  }
  /**
   * signal - an atomic signal that has start and stop paired automatically
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} message - a custom message for the activity itself
   * @returns {undefined} - no returns
   */


  signal(scenario, activity, parentScenario, [message, api]) {
    this.stopSignal(scenario, activity, parentScenario, [message, api, false]);
  }
  /**
   * withSignalSync - caller provides a function
   * start and stop are measure at start and stop of the function
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} action - caller provided function as the signal
   * action may return message as custom message
   * @returns {undefined} - no returns
   */


  withSignalSync(scenario, activity, parentScenario, [action]) {
    this.startSignal(scenario, activity);
    const actionReturn = action();
    this.stopSignal(scenario, activity, parentScenario, actionReturn ? [actionReturn.message, actionReturn.api] : []);
    return actionReturn;
  }
  /**
   * withSignalAsync - async version of withSignalAsync, caller provides a promise
   * start and stop are measure at start and stop of the prmoise
   * @param {object} scenario - scenario of activity that invoked log method
   * @param {object} activity - activity that invoked the log method
   * @param {object} parentScenario - parent of the scenario
   * @param {object} prmoise - caller provided promise as the signal
   * @returns {undefined} - no returns
   */


  withSignalAsync(scenario, activity, parentScenario, [promise]) {
    this.startSignal(scenario, activity);

    const onPromiseDone = promiseReturn => {
      this.stopSignal(scenario, activity, parentScenario, promiseReturn ? [promiseReturn.message, promiseReturn.api] : []);
    };

    promise.then(onPromiseDone, onPromiseDone);
    return promise;
  }

  getLogMethods() {
    return ['startSignal', 'stopSignal', 'signal', 'withSignalSync', 'withSignalAsync'];
  }

}

exports.SubstrateLogger = SubstrateLogger;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggingService = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _scenarioFactory = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * LoggingService class responsible for setting up scenarioFactories
 */
class LoggingService {
  /**
   * @param {object} options - contains the loggers/debugMode to be used
   */
  constructor(options) {
    this.loggers = options.loggers;
    this.isDebugMode = options.isDebugMode; // Record (scenario, activity) map for duplication check in debug mode

    this.registry = this.isDebugMode ? {} : undefined;
  }

  checkSchemaDuplication(scenarios) {
    /* eslint-disable no-restricted-syntax */
    if (this.isDebugMode && this.registry !== undefined) {
      for (const scenario of scenarios) {
        const scenarioName = scenario.name,
              activities = scenario.activity; // eslint-disable-next-line no-undef

        this.registry[scenarioName] = this.registry[scenarioName] || new Set();

        for (const _ref of activities) {
          const activityName = _ref.name;

          if (this.registry[scenarioName].has(activityName)) {
            throw new Error(`[Debug] Scenario: ${scenarioName} Activity: ${activityName} already registered.`);
          }

          this.registry[scenarioName].add(activityName);
        }
      }
    }
    /* eslint-enable no-restricted-syntax */

  }

  parseSchema(scenarioSchema) {
    const scenarios = scenarioSchema.scenario;
    this.checkSchemaDuplication(scenarios);
    const scenarioFactories = {};

    _underscore.default.each(scenarios, scenario => {
      scenarioFactories[scenario.name] = new _scenarioFactory.ScenarioFactory(scenario, this.loggers);
    });

    return scenarioFactories;
  }

}

exports.LoggingService = LoggingService;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScenarioFactory = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _primitiveUtilities = __webpack_require__(6);

var _activityFactory = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Scenario class to create an instance of a Scenario
 */
class Scenario {
  constructor(scenarioSchema, loggers, parentScenario) {
    this.value = scenarioSchema.value;
    this.name = scenarioSchema.name;
    this.id = (0, _primitiveUtilities.generateGuid)();
    this.setting = scenarioSchema.setting;
    this.loggers = loggers;
    this.parentScenario = parentScenario;
    const activities = scenarioSchema.activity;

    _underscore.default.each(activities, activity => {
      this[typeof activity === 'string' ? activity : activity.name] = new _activityFactory.ActivityFactory(this, activity, loggers, parentScenario);
    });
  }

  createActivity(activityName) {
    return new _activityFactory.ActivityFactory(this, activityName, this.loggers, this.parentScenario).create();
  }

}
/**
* ScenarioFactory class responsible for creating Scenario
*/


class ScenarioFactory {
  /**
   * @param {object} scenarioSchema - schema of scenario to be created
   * @param {object} loggers - available loggers
   */
  constructor(scenarioSchema, loggers) {
    this.scenarioSchema = scenarioSchema;
    this.loggers = loggers;
  }

  create(parentScenario) {
    return new Scenario(this.scenarioSchema, this.loggers, parentScenario);
  }

}

exports.ScenarioFactory = ScenarioFactory;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityFactory = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _primitiveUtilities = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Activity class to create an instance of an Activity
 */
class Activity {
  constructor(scenario, activitySchema, loggers, parentScenario) {
    const simpleActivity = typeof activitySchema === 'string';
    this.name = simpleActivity ? activitySchema : activitySchema.name;
    this.value = simpleActivity ? activitySchema : activitySchema.value;
    this.setting = simpleActivity ? undefined : activitySchema.setting;
    this.id = (0, _primitiveUtilities.generateGuid)(); // Add logger methods on the activity

    _underscore.default.each(loggers, logger => {
      const logMethods = logger.getLogMethods();

      _underscore.default.each(logMethods, logMethod => {
        this[logMethod] = (...args) => logger[logMethod](scenario, this, parentScenario, args);
      });
    });
  }

}
/**
 * ActivityFactory class responsible for creating Activity
 */


class ActivityFactory {
  /**
   * @param {object} scenario - scenario the activity belongs to
   * @param {object} activitySchema - schema of scenario to be created
   * @param {object} loggers - available loggers
   * @param {object} parentScenario - parentScenario of the scenario
   */
  constructor(scenario, activitySchema, loggers, parentScenario) {
    this.scenario = scenario;
    this.activitySchema = activitySchema;
    this.parentScenario = parentScenario;
    this.loggers = loggers;
  }

  create() {
    return new Activity(this.scenario, this.activitySchema, this.loggers, this.parentScenario);
  }

}

exports.ActivityFactory = ActivityFactory;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogTransmitter = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * LogTransmitter class responsible for transmitting logs to listeners
 */
class LogTransmitter {
  /**
   * @param {object} options - has listeners, optional processors and scenarioContext
   */
  constructor(options = {}) {
    this.listeners = options.listeners;
    this.processors = options.processors;
    this.scenarioContext = options.scenarioContext;
  }
  /**
   * Updates shared scenario context every time we write, so it can be read(as parentScenario)
   * by internal activities when writing logs
   * @param {object} rawLogs - the raw logs being transmitted to the listeners
   * @returns {undefined} - no returns
   */


  updateScenarioContext(rawLogs) {
    // Scenario is marked hidden for non user defined scenarios
    const isHiddenScenario = _underscore.default.result(rawLogs.scenario.setting, 'hidden');

    if (!isHiddenScenario) {
      this.scenarioContext.id = rawLogs.scenario.id;
      this.scenarioContext.value = rawLogs.scenario.value;
    }
  }

  transmit(rawLogs) {
    if (this.stopped) {
      return;
    }

    if (_underscore.default.has(rawLogs, 'scenario')) {
      this.updateScenarioContext(rawLogs);
    } // Pass the rawLogs through each procesor to enrich them


    let processedLogs = rawLogs;

    _underscore.default.each(this.processors, processor => {
      processedLogs = processor.process(processedLogs);
    });

    _underscore.default.each(this.listeners, listener => listener.write(processedLogs));
  }
  /**
   * Stop the log transmitter service by tearing down the listeners
   * @returns {undefined} - no returns
   */


  stop() {
    _underscore.default.each(this.listeners, listener => {
      listener.teardown();
    });

    this.stopped = true;
  }

}

exports.LogTransmitter = LogTransmitter;

/***/ })
/******/ ]);
});
